<template>
  <div class="catalogue">
    <Spin fix v-if="spinShow" size="large"
      ><Icon type="ios-loading" size="28" class="demo-spin-icon-load"></Icon>
      <div style="font-size:20px">加载中......</div>
    </Spin>
    <iframe
      id="iframe1"
      ref="iframeml"
      width="100%"
      height="100%"
      :src="url"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import { ztkalogin } from '@/api/user.js'
import urlObj from '@/config/env.js'
export default {
  data() {
    return {
      spinShow: true,
      url: '',
      getdata: {},
      ceshi: [],
      cataloguevalue: ''
      // token: '',
      // userInfo: {}
    }
  },
  beforeCreate() {
    // ztkalogin({ username: 'wss', password: 'Jp1234565@' }).then((res) => {
    //   console.log(res)
    //   if (res.code == 0) {
    //     let userData = JSON.parse(localStorage.getItem('userData'))
    //     this.url = `${urlObj.ztka1}/#/new-vin/vin-search1?vin=WDCBB8GB1BA745825&token=${res.data.token}&type=${res.data.userinfo.version}&id=${userData.id}&userName=${userData.username}&showXJ=true`
    //   }
    // })
  },
  created() {
    this.ztkaLogin()
    this.ceshi2()
  },
  methods: {
    async ztkaLogin() {
      const res = await ztkalogin({
        username: 'wss',
        password: 'Jp123456@'
      })
      let userData = JSON.parse(localStorage.getItem('userData'))
      console.log(userData)
      this.token = res.data.token
      this.userInfo = res.data.userinfo
      this.url = `${urlObj.ztka1}/#/new-vin/vin-search1?&token=${res.data.token}&type=${res.data.userinfo.version}&id=${userData.id}&userName=${userData.username}&showXJ=true&hasHeard=true`
      this.spinShow = false
    },

    ceshi2() {
      let receiveMessage1 = (e) => {
        console.log(e, '5555')
        if (e.data) {
          this.getdata = JSON.parse(JSON.stringify(e.data))
          console.log(this.getdata)
          let oecodes = []
          oecodes = this.getdata.map((item) => {
            return item.oeCode
          })
          console.log(oecodes)
          const val = oecodes.join(',')
          console.log(val)
          this.$router.push({
            path: '/partsSearch',
            query: { searchContent: val }
          })
          // this.getdata=[]
        } else {
          return false
        }
        // if (e.data.message) {
        //   // this.getdata = JSON.stringify(e.data.message)
        //   this.getdata = JSON.parse(JSON.stringify(e.data))
        //   console.log(this.getdata)
        //   for (let index = 0; index < this.getdata.length; index++) {
        //     const element = this.getdata[index]
        //     console.log(element)
        //     for (let index = 0; index < element.sysOeCode.length; index++) {
        //       var element1 = element.sysOeCode[index]
        //       this.ceshi.push(element1)
        //     }
        //   }
        //   console.log(this.ceshi)
        //   this.ceshi = this.ceshi.join(',')
        //   console.log(this.ceshi)
        //   this.$router.push({
        //     path: '/partsSearch',
        //     query: { searchContent: this.ceshi }
        //   })
        //   // console.log(this.$route.query(searchContent))
        //   // 清除监听事件的
        //   // window.removeEventListener('message', receiveMessage, true)
        // } else {
        //   return false
        // }
        console.log(e)
      }
      window.addEventListener('message', receiveMessage1, true)
    },
    toChild() {
      this.cataloguevalue = localStorage.getItem('userId')
      let id = document.getElementById('iframe1')
      id.contentWindow.postMessage({ message: this.cataloguevalue }, '/')
    }
  }
}
</script>

<style lang="less" scoped>
.catalogue {
  height: 100%;
  .demo-spin-col {
    height: 100%;
    position: relative;
    border: 1px solid #eee;
  }
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
}
</style>
